<template>
	<v-modal>
		<template v-slot:header>
			<h1>Assign Lead</h1>
		</template>
		<form class="wide" @submit.prevent="submit">
			<loader v-if="!formReady"/>
			<div v-if="formReady">
				<fieldset>
					<div>
						<div>
							<label><span>Call Centre </span>
								<div v-if="form.errors.get('call_centre')" class="error-block">
									<p v-html="form.errors.get('call_centre')"></p>
								</div>
								<select v-model="form.data.call_centre">
									<option selected value="">—</option>
									<option
										v-for="(serviceProvider, serviceProviderIndex) in form.options.callCentres"
										:key="serviceProviderIndex"
										:value="serviceProvider.id"
										v-html="serviceProvider.profile.name"/>
								</select>
							</label>
							<label v-if="!form.data.call_centre"><span>Service Provider </span>
								<div v-if="form.errors.get('service_provider')" class="error-block">
									<p v-html="form.errors.get('service_provider')"></p>
								</div>
								<select v-model="form.data.service_provider">
									<option selected value="">—</option>
									<option
										v-for="(serviceProvider, serviceProviderIndex) in form.options.serviceProviders"
										:key="serviceProviderIndex"
										:value="serviceProvider.id"
										v-html="serviceProvider.profile.name"/>
								</select>
							</label>
						</div>
					</div>
				</fieldset>
			</div>
		</form>
		<template v-slot:footer>
			<ul class="actions">
				<li>
					<button
						:disabled="form.processing" class="button button--secondary" @click.prevent="close">Cancel
					</button>
				</li>
				<li>
					<process-button
						:processing="form.processing" class="button button--primary" text="Assign Lead"
						@click="assign"/>
				</li>
			</ul>
		</template>
	</v-modal>
</template>
<script>

export default {
	data() {
		return {
			formReady: false,
			form: this.newForm({
				call_centre: "",
				service_provider: "",
			}),
		};
	},

	props: {
		lead: {
			required: true,
			type: Object,
		},
	},

	methods: {
		close() {
			this.$vmodal.close();
		},
		assign() {
			this.form.patch(this.route("missed-leads/:lead/assign", this.lead)).then(response => {
				this.$store.dispatch("missedLeads/getModels");
				this.close();
			});
		},
	},

	created() {
		http().get(this.route("form-data/assign-missed-lead/:lead", this.lead)).then(response => {
			this.form.setOptions(response.data);
			this.formReady = true;
		});
	},
};
</script>
